let tabForm = document.querySelector(".tab-form");
if (tabForm) {
  let tabHeader = tabForm.querySelector(".tab-header");
  let tabHeaderElements = tabForm.querySelectorAll(".tab-header > div");
  let tabBody = tabForm.querySelector(".tab-body");
  let tabBodyElements = tabForm.querySelectorAll(".tab-body > div");

  if (tabBodyElements.length > 0) {
    for (let i = 0; i < tabHeaderElements.length; i++) {
      tabHeaderElements[i].addEventListener("click", function() {
        tabHeader.querySelector(".active").classList.remove("active");
        tabHeaderElements[i].classList.add("active");
        tabBody.querySelector(".active").classList.remove("active");
        tabBodyElements[i].classList.add("active");
      });
    }
  }
}



// WEBPACK FOOTER //
// ./client/src/site__scf001/components/tab-form/index.js